module.exports = __webpack_public_path__ + "img/045-file.ff000e70.svg";